module.exports = __webpack_public_path__ + "img/logo_firefox.2f49970e.svg";